import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'

export const Route = createFileRoute('/libra-dashboard/')({
  component: LibraDashboardPage,
  staticData: {
    title: 'Libra Dashboard',
  },
})
